import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/cool-hooks/react-wordpress-hooks/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "react-wordpress-hooks"
    }}>{`React WordPress Hooks`}</h1>
    <blockquote>
      <p parentName="blockquote">{`Set of hooks for WordPress REST API`}</p>
    </blockquote>
    <h3 {...{
      "id": "how-to-install"
    }}>{`How to Install`}</h3>
    <p>{`First, install the library in your project by npm:`}</p>
    <pre><code parentName="pre" {...{}}>{`$ npm install react-wordpress-hooks
`}</code></pre>
    <p>{`Or Yarn:`}</p>
    <pre><code parentName="pre" {...{}}>{`$ yarn add react-wordpress-hooks
`}</code></pre>
    <h3 {...{
      "id": "authentication"
    }}>{`Authentication`}</h3>
    <p>{`To add different authentication methods to WordPress you need to install addidtional plugins`}<br />{`
`}<a parentName="p" {...{
        "href": "https://developer.wordpress.org/rest-api/using-the-rest-api/authentication"
      }}>{`More informations here`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      